import React, { Fragment } from "react"
import { MdClose } from "react-icons/md"
import { useTranslation } from "react-i18next"

import { LazyImage } from "components"
import { productUnitsSymbol } from "constants"
import { calculateItemSalePrice, thousandSeparator } from "utils"
import classes from "./OhOrderCard.module.scss"

const OhOrderCard = props => {
  const { orderItem } = props

  const [t] = useTranslation()

  const specificationItems = orderItem.orderItemSpecifications.flatMap(item =>
    item.specificationItems
  )
  const wholeItems = specificationItems.filter(item => !item.portion || item.portion === "whole")
  const firstHalfItems = specificationItems.filter(item => item.portion === "firstHalf")
  const secondHalfItems = specificationItems.filter(item => item.portion === "secondHalf")

  const renderItems = items => items.map(specificationItem =>
    <div
      key={`${specificationItem.builderStepKey || "whole"}-${specificationItem.specificationItemId}`}
      className={classes["add-on"]}
    >
      <b className={classes["name"]}>
        {specificationItem.name}
        <MdClose />
        {specificationItem.quantity * orderItem.quantity}
      </b>
      {specificationItem.salePrice > 0 &&
        <span className={classes["price"]}>
          {thousandSeparator(
            specificationItem.salePrice * orderItem.quantity *
            (specificationItem.quantity - specificationItem.freeQuantity)
          )}
        </span>
      }
    </div>
  )

  const renderPortion = (title, items) => items.length > 0 &&
    <section className={classes["portion"]}>
      <div className={classes["portion-title"]}>{title}</div>
      {renderItems(items)}
    </section>

  return (
    <Fragment>
      <div className={classes["container"]}>
        <div className={classes["row"]}>
          <LazyImage
            className={classes["image"]}
            alt={orderItem.foodName}
            imageWidth={100}
            quality={60}
            src={orderItem.foodImageCover}
          />
          <div className={classes["info"]}>
            <span style={{ fontSize: "11px" }}>
              {t("کد_کالا")}:{" "}
              <strong style={{ fontSize: "11px" }}>
                {orderItem.foodCode}
              </strong>
            </span>
            <span className={classes["name"]}>
              {orderItem.foodName}
            </span>
            {
              !orderItem.isSimple &&
              <span className={classes["name"]}>
                {orderItem.option.name}
              </span>
            }
            <span>
              <b>
                {thousandSeparator(
                  calculateItemSalePrice(orderItem)
                )}
              </b>
              {" "}
              <MdClose />
              <b>
                {orderItem.quantity}{productUnitsSymbol[orderItem.unit]}
              </b>
            </span>
          </div>
        </div>
        <div className={classes["price"]}>
          <span>
            {thousandSeparator(
              calculateItemSalePrice(orderItem) *
              orderItem.quantity
            )}
          </span>
          {
            orderItem.systemDiscount > 0 &&
            <span>
              {thousandSeparator(
                -orderItem.systemDiscount
              )}
            </span>
          }
          {
            orderItem.addAmount > 0 &&
            <span>
              + {thousandSeparator(orderItem.addAmount)}
            </span>
          }
        </div>
      </div>
      {renderItems(wholeItems)}
      {renderPortion("نیمه اول", firstHalfItems)}
      {renderPortion("نیمه دوم", secondHalfItems)}
    </Fragment>
  )
}

export default OhOrderCard
